import { CURRENCY_CODE_TO_SYMBOL } from '../../constants';

export const getCurrencySymbol = (
  code: keyof typeof CURRENCY_CODE_TO_SYMBOL
) => {
  if (!code) {
    return '';
  }

  return CURRENCY_CODE_TO_SYMBOL[code] || code;
};
